import { createFileRoute } from '@tanstack/react-router';
import { DocPage } from '@/features/docs/doc-page';

export const Route = createFileRoute('/w/$workspaceId/docs/$docId')({
  // `?page=` selects a page of the doc; the first page opens otherwise.
  validateSearch: (search: Record<string, unknown>): { page?: string } => ({
    ...(typeof search.page === 'string' ? { page: search.page } : {}),
  }),
  component: DocRoute,
});

function DocRoute() {
  const { docId } = Route.useParams();
  const { page } = Route.useSearch();
  return <DocPage key={docId} docId={docId} pageId={page} />;
}
